import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const configurationService = {
  getAllConfigurations,
  updateConfiguration
};

const MODULE = {
  CONFIGURATION: 'configurations',
}

const API_URL = API.BASE_URL + '/v1'

export function getAllConfigurations() {
  return apiHelper(API_URL).get(`/${MODULE.CONFIGURATION}`)
}

export function updateConfiguration(key, value) {
  const requestOptions = {
    value: value
  }

  return apiHelper(API_URL).put(`/${MODULE.CONFIGURATION}/${key}`, requestOptions)
}
